import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ASSIGNMENT_MODE_INSURANCE } from "components/Assignment";
import { getInspectorDetails } from "actions/assignment";
import { MCard } from "components/Shared";
import { DATA_TYPE_PHONE_NUMBER, DATA_TYPE_STRING } from "typeConstants/dataTypes";

const FieldRepContactInfo = ({inspectorNumber, getInspectorDetails, isFetchingInspectorDetails, inspectorDetails}) => {

  useEffect(() => {
    getInspectorDetails(inspectorNumber);
  }, [inspectorNumber]);

  const getFields = () => {
    if(isFetchingInspectorDetails || !inspectorDetails)
      return [];

    return [
      { key: "email", label: "Email", value: inspectorDetails.email },
      { key: "homePhone", label: "Home Phone", value: inspectorDetails.homePhone, dataType: DATA_TYPE_PHONE_NUMBER },
      { key: "cellPhone", label: "Cell Phone", value: inspectorDetails.cellPhone, dataType: DATA_TYPE_PHONE_NUMBER },
      { key: "county", label: "County", value: inspectorDetails.inspectorLocation.county, dataType: DATA_TYPE_STRING },
      { key: "msa", label: "MSA", value: inspectorDetails.serviceRegionDisplayName, dataType: DATA_TYPE_STRING },
    ];
  };

  return (
    <MCard
      title={"Contact Information"}
      fields={getFields()}
    />
  );
};

FieldRepContactInfo.propTypes = {
  inspectorNumber: PropTypes.number.isRequired,
  getInspectorDetails: PropTypes.func,
  isFetchingInspectorDetails: PropTypes.bool,
  inspectorDetails: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    isFetchingInspectorDetails: state.assignment.isFetchingInspectorDetails,
    inspectorDetails: state.assignment.inspectorDetails,
  };
};

const mapDispatchToProps = dispatch => ({
  getInspectorDetails(inspectorNumber) {
    dispatch(getInspectorDetails(ASSIGNMENT_MODE_INSURANCE, inspectorNumber));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FieldRepContactInfo);